import Link from 'next/link';

export function NavLinks({ mobile }) {
  const links = [
    { href: '/services', label: 'Our Services' },
    { href: '/about', label: 'About Us' },
    { href: '/testimonials', label: 'Patient Stories' },
    { href: '/contact', label: 'Contact' },
  ];

  return (
    <nav className={mobile ? 'flex flex-col space-y-4' : 'hidden md:flex items-center space-x-4 lg:space-x-8'}>
      {links.map((link) => (
        <Link
          key={link.href}
          href={link.href}
          className={`text-secondary hover:text-primary transition-colors text-sm lg:text-base font-medium
            ${mobile ? 'block w-full' : ''}`}
        >
          {link.label}
        </Link>
      ))}
    </nav>
  );
}
